import { IconSearch } from "components/icons";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonSearch: React.FC<MprcIconButtonProps> = ({ title, children, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonSearch.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconSearch fixedWidth />
            {children}
        </MprcIconButton>
    );
};
